import IntlWrapper from '~/utils/intl/intl-wrapper';
import intlProxyFactory from '~/utils/intl/intl-proxy-factory';

const instance = new IntlWrapper();
const intlProxy = intlProxyFactory(instance);
export default intlProxy;
